'use client'

import { useEffect } from 'react'
import { captureAdLandingUrl } from '@/utils/adTracking'

export default function AdLandingCapture() {
  useEffect(() => {
    captureAdLandingUrl()
  }, [])

  return null
}
